import { api } from '@/api';
import { GetDeviceTrackingListParams } from '@/api/apis/route';
import { queryClient } from '@/queries';
import { deviceTrackingQueryKeys } from '@/queries/device-tracking';

export const seedDeviceTrackingFromList = async (params: GetDeviceTrackingListParams) => {
  const resp = await api.route.getDeviceTrackingList(params);

  resp.items.forEach((item) => {
    queryClient.setQueryData(deviceTrackingQueryKeys.getByCaseId(item.caseId), item);
  });

  return resp;
};
